var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',{attrs:{"editorToolbar":_vm.attribute.editorToolbar},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }